<template>
  <base-material-card :icon="resource.icon" :title="title">
    <va-list
      :filters="filters"
    >
      <va-data-table :fields="fields">
      </va-data-table>
    </va-list>
  </base-material-card>
</template>

<script>
export default {
  props: ["resource", "title"],
  data() {
    return {
        filters: ["title", "slug", "status", "start", "end"],
        fields: [
            { source: "title", sortable: true },
            { source: "start", type: "date", sortable: true },
            { source: "end", type: "date", sortable: true },
        ],
    };
  },
};
</script>
